import React, { useState } from 'react';

import OrgChartsContentHeader from './ContentHeader';
import OrgChartsGridView from './GridView';
import { OrgChartContentProps } from './interfaces';

const OrgChartsContent = ({
  companies,
  description,
  initialCurrentUser,
  title,
}: OrgChartContentProps) => {
  const [filteredCompanies, setFilteredCompanies] = useState(companies);

  const handleOnSearchTermChange = (searchTerm: string) => {
    const filteredCompanies = companies.filter((company) =>
      company.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCompanies(filteredCompanies);
  };

  return (
    <div className="mx-auto max-w-container-lg px-16 text-center">
      <OrgChartsContentHeader
        title={title}
        description={description}
        onSearchTermChange={handleOnSearchTermChange}
        user={initialCurrentUser}
      />
      <OrgChartsGridView companies={filteredCompanies} />
    </div>
  );
};

export default OrgChartsContent;
